const OBJECTS_TYPE_OPTIONS = [
  {
    label: 'Приложение',
    value: 'addon',
    icon: 'document-copy',
  },
  {
    label: 'Таблица',
    value: 'table',
    icon: 'grid',
  },
  {
    label: 'Рисунок',
    value: 'picture',
    icon: 'picture',
  },
  {
    label: 'Формула',
    value: 'formula',
    icon: 'eleme',
  },
];

export { OBJECTS_TYPE_OPTIONS };
